import { BffApiClientMolecule } from "@/app/api-client/store"
import { useCollection } from "@/app/collections/store/use-collection"
import {
  fetchSolanaCollectionOfferStandard,
  resolveSolanaCollectionOfferStandardFromType,
} from "@/app/solana/collection-nft-standard"
import {
  formatSolListingPriceFromNumber,
  parseSolanaListingPriceSolToLamports,
} from "@/app/solana/listing-price"
import { toCurrencyId } from "@anaconda/core/price/types"
import { sonnerToast } from "@rarible_int/anaconda_ui_components"
import { useMolecule } from "bunshi/react"
import { useCallback, useMemo } from "react"
import { getTransactionErrorMessage } from "../events/transaction-event"
import { SolanaCollectionOfferTransactionMoleculeReatom } from "./solana-collection-offer-molecule.reatom"

export function useSolanaCollectionOffer(collectionId: string) {
  const { collectionOfferActionFactory } = useMolecule(
    SolanaCollectionOfferTransactionMoleculeReatom,
  )
  const collectionOfferAction = useMemo(
    () => collectionOfferActionFactory(),
    [collectionOfferActionFactory],
  )
  const bffApiClient = useMolecule(BffApiClientMolecule)
  const collection = useCollection()

  const mutate = useCallback(
    (params: { price: number; currency: string }) => {
      void (async () => {
        try {
          const resolved =
            resolveSolanaCollectionOfferStandardFromType({
              collectionId,
              collectionType: collection.type,
            }) ??
            (await fetchSolanaCollectionOfferStandard(
              bffApiClient,
              collectionId,
            ))

          if (resolved.standard === "UNSUPPORTED" || !resolved.collectionMint) {
            sonnerToast.error(
              "This collection's NFT standard doesn't support collection offers yet.",
            )
            return
          }

          const priceInLamports = parseSolanaListingPriceSolToLamports(
            formatSolListingPriceFromNumber(params.price),
          )

          await collectionOfferAction({
            collectionAddress: resolved.collectionMint,
            nftStandard: resolved.standard,
            currency: toCurrencyId(params.currency),
            price: priceInLamports,
          }).catch(() => undefined)
        } catch (error) {
          sonnerToast.error(getTransactionErrorMessage(error))
        }
      })()
    },
    [collectionOfferAction, collectionId, collection.type, bffApiClient],
  )

  return {
    mutate,
    isPending: !!collectionOfferAction.pending(),
  }
}
